/* Micro-interactions: header scrolled-state + cart-count pop. Fail-safe. */
(function () {
  var d = document.documentElement;
  var onScroll = function () { d.classList.toggle('scrolled', window.scrollY > 40); };
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  function watchCart() {
    var icon = document.getElementById('cart-icon-bubble');
    if (!icon || !('MutationObserver' in window)) return;
    var mo = new MutationObserver(function () {
      var b = icon.querySelector('.cart-count-bubble');
      if (b) { b.classList.remove('cart-pop'); void b.offsetWidth; b.classList.add('cart-pop'); }
    });
    mo.observe(icon, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchCart);
  else watchCart();
})();
